<template>
    <va-create-layout>
        <SAFETReimbursementEventItemCharge-form
            :title="title"
            :item="item"
        ></SAFETReimbursementEventItemCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
